import { HtmlId } from '../enum';
import { createCarousel } from '@vfde-brix/ws10/carousel';
import { createComponentById, NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';

/**
 * Create Brix Carousel component.
 * @param {HtmlId} id - ID of the element.
 * @returns {Carousel | null} component or null if element with given id is not found
 */
export const mountCarousel = (id: HtmlId) =>
    createComponentById(createCarousel, id, NO_PATTERN_BUSINESS_LOGIC);
